import React from 'react'
import useFindMenu from '@hooks/useFindMenu'
import { Banner, BannerDouble, BannerNewsletter } from '@components/organisms'

interface Props {
  skipContatti?: boolean
  skipRivenditore?: boolean
  skipNewsletter?: boolean
}

const Prefooter = (props: Props) => {
  const { skipContatti = false, skipRivenditore = false, skipNewsletter = false } = props

  const prefooterMenu = useFindMenu('prefooter')
  const newsletterMenu = useFindMenu('banner-newsletter', prefooterMenu)
  const bannersMenu = useFindMenu('banners', prefooterMenu)
  const rivenditoreMenu = useFindMenu('banner-rivenditore', bannersMenu)
  const contattiMenu = useFindMenu('banner-contatti', bannersMenu)
  const bannersMenuFinal = []
    .concat(skipContatti || !contattiMenu ? [] : [contattiMenu])
    .concat(skipRivenditore || !rivenditoreMenu ? [] : [rivenditoreMenu])

  return (
    <>
      {bannersMenuFinal.length > 1 ? (
        <BannerDouble items={bannersMenu.children} />
      ) : bannersMenuFinal.length === 1 ? (
        <Banner
          item={bannersMenuFinal[0]}
          type={bannersMenuFinal[0]?.key === 'banner-rivenditore' ? 'right' : 'left'}
          theme="neutral20"
        />
      ) : (
        <></>
      )}
      {newsletterMenu && !skipNewsletter && <BannerNewsletter item={newsletterMenu} />}
    </>
  )
}

export default Prefooter
